import { AccountBookTwoTone, WalletOutlined } from '@ant-design/icons';
import { InputNumber, Space, Typography } from 'antd';
import BigNumber from 'bignumber.js';
import React, { useEffect } from 'react';
import { NumericKeyboardInput } from '@/components/NumericKeyboard';
import PosButton from '@/components/PosButton';
import Price from '@/components/Price';
import { User } from '@/models/user';
import { playSound } from '@/utils/sound';
import styles from './style.less';

type Props = {
  user: User;
  /**待收款总额 */
  actualPrice: BigNumber;
  totalPrice: BigNumber;
  /** 使用余额支付金额 */
  value?: BigNumber;
  onChange?: (value: BigNumber) => void;
};

const BalanceConsume: React.FC<Props> = ({ user, actualPrice, totalPrice, value, onChange }: Props) => {
  const balancePriceMaxLimit = BigNumber.min(user?.balance, totalPrice);
  // 依赖值化：BigNumber 实例每次渲染都是新引用，直接依赖会每次渲染触发 effect
  const balancePriceMaxLimitNum = balancePriceMaxLimit.toNumber();
  const valueNum = value ? value.toNumber() : 0;
  const actualPriceNum = actualPrice.toNumber();

  useEffect(() => {
    // 如果 actualPrice 发生变化 （使用积分、优惠券），需要重新计算
    // 如果当前余额扣款超过最大限制，重新设置余额抵扣金额
    // （valueNum > 0 排除"未设置余额"：null 表示未设置，0 也无需修正）
    if (valueNum > 0 && valueNum > balancePriceMaxLimitNum) {
      onChange(balancePriceMaxLimit);
    }
  }, [balancePriceMaxLimitNum, actualPriceNum, valueNum]);

  if (!user || !user.balance || totalPrice.isLessThanOrEqualTo(0)) {
    return null;
  }

  return (
    <>
      <div className={styles.balanceWrapper}>
        <div className={styles.balanceMain}>
          <h2 style={{ fontSize: 16 }}>
            <WalletOutlined /> 客户账户余额: <Price value={user.balance} />, 已使用 <Price value={value ? value : 0} />
            {/* --- 本单可结算 <Typography.Text code>{balancePriceMaxLimit.toNumber()}</Typography.Text>
            元 */}
          </h2>
          {balancePriceMaxLimit.gt(0) && (
            <div>
              <Space size={10}>
                <NumericKeyboardInput
                  value={value ? value.toNumber() : 0}
                  inputType={InputNumber}
                  onChange={v => {
                    if (!v) {
                      onChange(undefined);
                    } else {
                      if (+v > balancePriceMaxLimit.toNumber()) {
                        onChange(balancePriceMaxLimit);
                      } else {
                        onChange(new BigNumber(v));
                      }
                    }
                  }}
                  inputProps={{
                    placeholder: '请输入使用余额金额',
                    style: { width: '100%' },
                    min: 0,
                    max: balancePriceMaxLimit.toNumber(),
                    precision: 2,
                  }}
                  keyboardProps={{
                    parseValueToNumber: true,
                    precision: 2,
                    showAllClean: true,
                    placement: 'right',
                    trigger: 'click',
                    style: { width: 300 },
                  }}
                />
                <PosButton
                  onClick={() => {
                    onChange(balancePriceMaxLimit);
                    playSound('click');
                  }}>
                  全部使用
                </PosButton>
                <PosButton
                  onClick={() => {
                    onChange(undefined);
                    playSound('click');
                  }}>
                  重置
                </PosButton>
              </Space>
            </div>
          )}
        </div>
        <div>
          <h2>
            <AccountBookTwoTone twoToneColor={'#eb2f96'} /> 还需收款: <Price value={actualPrice} />
          </h2>
        </div>
      </div>
    </>
  );
};

export default BalanceConsume;
